import React, { FC } from 'react'

import { Switch } from 'react-router'
import PrivateRoute from '../../components/Routes/PrivateRoute'
import GuestRoutes from '../../components/Routes/GuestRoute'
import SimpleRoute from '../../components/Routes/SimpleRoute'

import Login from '../Login'
import Signup from '../Signup'
import ForgotPassword from '../ForgotPassword'
import ResetPassword from '../ResetPassword'
import CreateAgency from '../CreateAgency'
import CreateProject from '../CreateProject'
import CreatePost from '../CreatePost'
import Calendar from '../Calendar'
import CalendarInternalApproval from '../Calendar-approval'
import Content from '../Content'
import ApprovalList from '../ApprovalList'
import ApprovalItem from '../Approvaltem'
// import Reports from '../Reporting'
import Analytics from '../Analytics'
import SocialAccoutns from '../Settings/SocialAccounts/index'
import EditProject from '../Settings/Project'
import Team from '../Settings/Team/index'
import Client from '../Settings/Client/index'
import Notifications from '../Settings/Notifications/index'
import Hashtag from '../Settings/Hashtag/index'

import LinkedinCallBack from '../ConnectSocialAccounts/LinkedinCallBack'
import TwitterCallBack from '../ConnectSocialAccounts/TwitterCallBack'
import FacebookConnect from '../ConnectSocialAccounts/FacebookConnect'
import InstagramConnect from '../ConnectSocialAccounts/InstagramConnect'
import LinkedinConnect from '../ConnectSocialAccounts/LinkedinConnect'
import TwitterConnect from '../ConnectSocialAccounts/TwitterConnect'

import AuthLayout from '../../layouts/Authentication'
import OnboardingStep from '../../layouts/OnboardingStep'
import Main from '../../layouts/Main'
import PreviewPosts from '../../layouts/PreviewPosts'
import Approval from '../../layouts/Approval'

import NoProject from '../NoProject/Index'
import ActionStatusModal from '../../components/UI/ActionStatusModal'
import Preloader from '../../components/Preloader'
import TransparentPreloader from '../../components/TransparentPreloader'

import AddCard from '../AddCard'
import Billing from '../Billing';
import { useSelector } from '../../store'

import Roles from '../../models/roles'

interface RouterProps {}

export enum NON_AUTH_ROUTE {
  LOGIN = '/',
  SIGNUP = '/signup',
  RESET_PASSWORD = '/reset-password',
  CHANGE_PASSWORD = '/change-password'
}

export enum AUTH_ROUTE {
  CREATE_AGENCY = '/create-agency/:step',
  CREATE_PROJECT = '/create-project/:step',
  EMPTY_PROJECTS = '/without-project',
  CALENDAR = '/:projectId/calendar',
  CONTENT = '/:projectId/content',
  MANAGE_POST = '/:projectId/manage-post/:social',
  CALENDAR_APPROVAL = '/:projectId/calendar-approval',
  APPROVAL_LIST = '/:projectId/approval',
  APPROVAL_ITEM = '/:projectId/approval/:social',
  UNAPPROVE_ITEM = '/:projectId/unapprove/:social',
  REPORTS = '/:projectId/reporting',
  ANALYTICS = '/:projectId/analytics/:social',
  SOCIAL_ACCOUNTS = '/:projectId/settings/social-accounts',
  TEAM = '/:projectId/settings/team',
  CLIENT = '/:projectId/settings/client',
  NOTIFICATIONS = '/:projectId/settings/notifications',
  HASHTAG = '/:projectId/settings/hashtag',
  LABELS = '/:projectId/settings/labels',
  GENERAL_SETTINGS = '/:projectId/settings/general',
  BILLING = '/billing',
  FACEBOOK_CONNECT = '/:projectId/facebook/connect',
  INSTAGRAM_CONNECT = '/:projectId/instagram/connect',
  LINKEDIN_CONNECT = '/:projectId/linkedin/connect',
  TWITTER_CONNECT = '/:projectId/twitter/connect',
  LINKEDIN_CALLBACK = '/linkedin/callback',
  TWITTER_CALLBACK = '/twitter/callback',
  ADD_CARD = '/add-card'
}

const Router: FC<RouterProps> = (props) => {

  const { user } = useSelector(({ auth: { user }}) => ({
    user
  }))

  return (
    <div className='app-container'>
      <Switch>
        {/* Unauthenticated routes */}
        <GuestRoutes path={NON_AUTH_ROUTE.LOGIN} layout={AuthLayout} component={Login} exact />
        <GuestRoutes path={NON_AUTH_ROUTE.SIGNUP} layout={AuthLayout} component={Signup} />
        <SimpleRoute
          path={NON_AUTH_ROUTE.RESET_PASSWORD}
          layout={OnboardingStep}
          component={ForgotPassword}
        />
        <SimpleRoute
          path={NON_AUTH_ROUTE.CHANGE_PASSWORD}
          layout={OnboardingStep}
          component={ResetPassword}
        />
        {/* Authenticated routes */}
        <PrivateRoute
          path={AUTH_ROUTE.ADD_CARD}
          layout={OnboardingStep}
          component={AddCard}
          roles={[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.CREATE_AGENCY}
          layout={OnboardingStep}
          component={CreateAgency}
          roles={[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.EMPTY_PROJECTS}
          layout={OnboardingStep}
          component={NoProject}
          roles={[
            Roles.CONTENT_CREATOR,
            Roles.AGENCY_ADMIN,
            Roles.INTERNAL_APPROVER,
            Roles.EXTERNAL_APPROVER
          ]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.CREATE_PROJECT}
          layout={OnboardingStep}
          component={CreateProject}
          roles={[Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.CALENDAR}
          layout={Main}
          component={Calendar}
          roles={[Roles.CONTENT_CREATOR, Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.CONTENT}
          layout={Main}
          component={Content}
          roles={[Roles.CONTENT_CREATOR, Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.MANAGE_POST}
          layout={PreviewPosts}
          component={CreatePost}
          roles={[Roles.CONTENT_CREATOR, Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.CALENDAR_APPROVAL}
          layout={Main}
          component={CalendarInternalApproval}
          roles={[
            Roles.EXTERNAL_APPROVER,
            Roles.INTERNAL_APPROVER
          ]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.APPROVAL_LIST}
          layout={Approval}
          exact
          component={ApprovalList}
          roles={[
            Roles.EXTERNAL_APPROVER,
            Roles.INTERNAL_APPROVER,
            Roles.AGENCY_ADMIN,
            Roles.SUPER_ADMIN
          ]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.APPROVAL_ITEM}
          layout={Approval}
          component={ApprovalItem}
          roles={[
            Roles.EXTERNAL_APPROVER,
            Roles.INTERNAL_APPROVER,
            Roles.AGENCY_ADMIN,
            Roles.SUPER_ADMIN
          ]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.UNAPPROVE_ITEM}
          layout={Approval}
          component={ApprovalItem}
          roles={[
            Roles.EXTERNAL_APPROVER,
            Roles.INTERNAL_APPROVER,
            Roles.AGENCY_ADMIN,
            Roles.SUPER_ADMIN
          ]}
        />
        {/* <PrivateRoute
          path={AUTH_ROUTE.REPORTS}
          layout={Main}
          component={Reports}
          roles={[Roles.CONTENT_CREATOR, Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN]}
        /> */}
        <PrivateRoute
          path={AUTH_ROUTE.ANALYTICS}
          layout={Main}
          component={Analytics}
          roles={[Roles.CONTENT_CREATOR, Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.SOCIAL_ACCOUNTS}
          layout={Main}
          component={SocialAccoutns}
          roles={[Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.TEAM}
          layout={Main}
          component={Team}
          roles={[Roles.AGENCY_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.CLIENT}
          layout={Main}
          component={Client}
          roles={[Roles.AGENCY_ADMIN]}
        />
         <PrivateRoute
          path={AUTH_ROUTE.NOTIFICATIONS}
          layout={Main}
          component={Notifications}
          roles={[Roles.AGENCY_ADMIN,Roles.AGENCY_ADMIN,Roles.CONTENT_CREATOR,Roles.INTERNAL_APPROVER,Roles.EXTERNAL_APPROVER]}
        />
          <PrivateRoute
          path={AUTH_ROUTE.HASHTAG}
          layout={Main}
          component={Hashtag}
          roles={[Roles.AGENCY_ADMIN,Roles.AGENCY_ADMIN,Roles.CONTENT_CREATOR,Roles.INTERNAL_APPROVER,Roles.EXTERNAL_APPROVER]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.LABELS}
          layout={Main}
          component={Team}
          roles={[Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
       <PrivateRoute
          path={(user && [Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN].includes(user.agency_role))?AUTH_ROUTE.GENERAL_SETTINGS:AUTH_ROUTE.NOTIFICATIONS}
          layout={Main}
          component={(user && [Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN].includes(user.agency_role))?EditProject:Notifications}
          roles={(user && [Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN].includes(user.agency_role))?[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN]:[Roles.AGENCY_ADMIN,Roles.AGENCY_ADMIN,Roles.CONTENT_CREATOR,Roles.INTERNAL_APPROVER,Roles.EXTERNAL_APPROVER]}
        />
         <PrivateRoute
          path={AUTH_ROUTE.BILLING}
          layout={Main}
          component={Billing}
          roles={[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN]}
        />
        {/* Connecting social accounts */}
        <PrivateRoute
          path={AUTH_ROUTE.FACEBOOK_CONNECT}
          layout={(props: any) => <>{props.children}</>}
          component={FacebookConnect}
          roles={[Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.INSTAGRAM_CONNECT}
          layout={(props: any) => <>{props.children}</>}
          component={InstagramConnect}
          roles={[Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.LINKEDIN_CONNECT}
          layout={(props: any) => <>{props.children}</>}
          component={LinkedinConnect}
          roles={[Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.TWITTER_CONNECT}
          layout={(props: any) => <>{props.children}</>}
          component={TwitterConnect}
          roles={[Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.LINKEDIN_CALLBACK}
          layout={(props: any) => <>{props.children}</>}
          component={LinkedinCallBack}
          roles={[Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
        <PrivateRoute
          path={AUTH_ROUTE.TWITTER_CALLBACK}
          layout={(props: any) => <>{props.children}</>}
          component={TwitterCallBack}
          roles={[Roles.AGENCY_ADMIN, Roles.AGENCY_ADMIN]}
        />
        {/* Connecting social accounts */}
      </Switch>
      <Preloader isGlobal={true} />
      <TransparentPreloader />
      <ActionStatusModal />
    </div>
  )
}

export default Router
